module.exports = __webpack_public_path__ + "media/src/assets/Images/Instagram-70165b1aec69182f3910929aaf4c85b6.svg";